import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function OfferSection() {
  return <section id="pricing" className="py-16 md:py-[80px] px-4 bg-[#050505] border-y border-border relative overflow-hidden" data-id="element-111">
      {/* Glow effect behind */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-112" />

      <div className="max-w-[800px] mx-auto relative z-10" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="overflow-hidden rounded-lg border-2 border-gold bg-surface shadow-[0_0_40px_rgba(245,200,66,0.1)]" data-id="element-114">
          <div className="flex items-center gap-2 border-b border-border bg-surface-light px-[18px] py-3 justify-center" data-id="element-115">
            <div className="h-1.5 w-1.5 rounded-full bg-gold animate-pulse" data-id="element-116"></div>
            <div className="font-heading text-[10px] font-bold tracking-[3px] text-gold uppercase" data-id="element-117">
              Oferta de Validación
            </div>
          </div>

          <div className="p-8 md:p-12" data-id="element-118">
            <div className="mb-8 text-center" data-id="element-119">
              <p className="text-[14px] text-text-secondary mb-4 leading-[1.8]" data-id="element-120">
                Podría vender este sistema por{' '}
                <span className="line-through decoration-red-500/50" data-id="element-121">$97</span>{' '}
                o incluso{' '}
                <span className="line-through decoration-red-500/50" data-id="element-122">$197</span>
                , y seguiría siendo una ganga comparado con los miles de dólares
                que pierdes cada mes por culpa de tu estancamiento.
              </p>
              <p className="text-[15px] font-bold text-white" data-id="element-123">
                Pero hoy, como parte de este lanzamiento de validación, puedes
                obtener el Código de Identidad 1.0 por solo:
              </p>
            </div>

            <div className="my-8 text-center" data-id="element-124">
              <span className="font-heading text-7xl md:text-[90px] font-black text-gold tracking-tighter leading-none drop-shadow-lg" data-id="element-125">
                $6.39{' '}
                <span className="text-3xl md:text-4xl tracking-normal" data-id="element-126">
                  USD
                </span>
              </span>
            </div>

            <div className="max-w-lg mx-auto mb-8 text-center" data-id="element-127">
              <img src="https://cdn.magicpatterns.com/uploads/iBw6vUSaqNBggWK3KQ7K5H/Imagen_Codigo_de_identidad-3.png" alt="El Código de Identidad 1.0" className="w-full max-w-sm mx-auto h-auto drop-shadow-2xl mb-6" data-id="element-128" />
            </div>

            {/* BONUSES */}
            <div className="mb-8" data-id="element-129">
              <div className="mb-4 flex items-center justify-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-gold uppercase" data-id="element-130">
                <span className="inline-block h-[2px] w-5 bg-gold" data-id="element-131"></span>
                Bonos Incluidos
                <span className="inline-block h-[2px] w-5 bg-gold" data-id="element-132"></span>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-133">
                <div className="rounded-lg border border-[#1e1e1e] bg-[#111] overflow-hidden" data-id="element-134">
                  <div className="flex items-center justify-between border-b border-[#1e1e1e] bg-[#161616] px-4 py-2.5" data-id="element-135">
                    <div className="flex items-center gap-2" data-id="element-136">
                      <span className="text-[16px]" data-id="element-137">📘</span>
                      <span className="font-heading text-[11px] font-black uppercase tracking-[0.5px] text-white" data-id="element-138">
                        El Manual Maestro
                      </span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-139">
                      <span className="text-[11px] text-[#666] line-through" data-id="element-140">
                        $47
                      </span>
                      <span className="rounded-sm bg-[#4caf50] px-2 py-0.5 font-heading text-[9px] font-black tracking-[1px] text-black uppercase" data-id="element-141">
                        GRATIS
                      </span>
                    </div>
                  </div>
                  <div className="px-4 py-3 text-[12px] leading-[1.6] text-[#888]" data-id="element-142">
                    La guía paso a paso para identificar tus puntos ciegos y
                    pasar de deudas masivas a generar millones operando desde el
                    ser.
                  </div>
                </div>

                <div className="rounded-lg border border-[#1e1e1e] bg-[#111] overflow-hidden" data-id="element-143">
                  <div className="flex items-center justify-between border-b border-[#1e1e1e] bg-[#161616] px-4 py-2.5" data-id="element-144">
                    <div className="flex items-center gap-2" data-id="element-145">
                      <span className="text-[16px]" data-id="element-146">🌡️</span>
                      <span className="font-heading text-[11px] font-black uppercase tracking-[0.5px] text-white" data-id="element-147">
                        La Matriz del Termostato
                      </span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-148">
                      <span className="text-[11px] text-[#666] line-through" data-id="element-149">
                        $37
                      </span>
                      <span className="rounded-sm bg-[#4caf50] px-2 py-0.5 font-heading text-[9px] font-black tracking-[1px] text-black uppercase" data-id="element-150">
                        GRATIS
                      </span>
                    </div>
                  </div>
                  <div className="px-4 py-3 text-[12px] leading-[1.6] text-[#888]" data-id="element-151">
                    Calcula tu límite subconsciente actual y las instrucciones
                    exactas para expandirlo un 300% de manera segura.
                  </div>
                </div>

                <div className="rounded-lg border border-[#1e1e1e] bg-[#111] overflow-hidden" data-id="element-152">
                  <div className="flex items-center justify-between border-b border-[#1e1e1e] bg-[#161616] px-4 py-2.5" data-id="element-153">
                    <div className="flex items-center gap-2" data-id="element-154">
                      <span className="text-[16px]" data-id="element-155">📊</span>
                      <span className="font-heading text-[11px] font-black uppercase tracking-[0.5px] text-white" data-id="element-156">
                        Auditoría de Frecuencia
                      </span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-157">
                      <span className="text-[11px] text-[#666] line-through" data-id="element-158">
                        $27
                      </span>
                      <span className="rounded-sm bg-[#4caf50] px-2 py-0.5 font-heading text-[9px] font-black tracking-[1px] text-black uppercase" data-id="element-159">
                        GRATIS
                      </span>
                    </div>
                  </div>
                  <div className="px-4 py-3 text-[12px] leading-[1.6] text-[#888]" data-id="element-160">
                    Identifica si estás operando en modo "Supervivencia" o en
                    modo "Creación" en tiempo real, cada día.
                  </div>
                </div>

                <div className="rounded-lg border border-gold/30 bg-gold/5 overflow-hidden" data-id="element-161">
                  <div className="flex items-center justify-between border-b border-gold/20 bg-gold/10 px-4 py-2.5" data-id="element-162">
                    <div className="flex items-center gap-2" data-id="element-163">
                      <span className="text-[16px]" data-id="element-164">🏆</span>
                      <span className="font-heading text-[11px] font-black uppercase tracking-[0.5px] text-gold" data-id="element-165">
                        El Manifiesto del Rico Educado
                      </span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-166">
                      <span className="text-[11px] text-[#666] line-through" data-id="element-167">
                        $57
                      </span>
                      <span className="rounded-sm bg-[#4caf50] px-2 py-0.5 font-heading text-[9px] font-black tracking-[1px] text-black uppercase" data-id="element-168">
                        GRATIS
                      </span>
                    </div>
                  </div>
                  <div className="px-4 py-3 text-[12px] leading-[1.6] text-[#bbb]" data-id="element-169">
                    Por qué las masas se entretienen mientras la élite se educa,
                    y cómo hackear tu consumo de información para acelerar tu
                    riqueza.
                  </div>
                </div>
              </div>

              <div className="mt-4 text-center" data-id="element-170">
                <p className="text-[12px] text-[#666]" data-id="element-171">
                  Valor total de los bonos:{' '}
                  <span className="line-through text-[#555]" data-id="element-172">$168 USD</span> —{' '}
                  <strong className="text-[#4caf50]" data-id="element-173">
                    Hoy incluidos GRATIS
                  </strong>
                </p>
              </div>
            </div>

            <div className="mb-8 rounded-lg border border-border bg-surface-dark px-[20px] py-[16px] text-[13px] italic leading-[1.7] text-text-quote text-center" data-id="element-174">
              Es menos de lo que cuesta una suscripción de Netflix que solo
              sirve para dormir tu cerebro. Es el precio de un café premium que
              te durará 10 minutos. Aquí te ofrezco la herramienta para
              despertar tu proyector mental de por vida.
            </div>

            <div className="flex justify-center" data-id="element-175">
              <CTAButton variant="purchase" data-id="element-176" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}